import { Component, forwardRef, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Observable, shareReplay } from "rxjs";

import { SelectorComponent } from "@components/selector/selector.component";
import { ControlValueAccessorBaseComponent } from "~app/common/components/base-component/control-value-accessor-base.component";
import { TransportforetagSearchResultDTO } from "~app/common/models/kontakter/TransportforetagSearchResultDTO";
import { TransportforetagService } from "../../transportforetag/services/transportforetag.service";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SokTransportforetagComponent)
        }
    ],
    selector: "rask-sok-transportforetag",
    templateUrl: "./sok-transportforetag.component.html",
    styleUrls: ["./sok-transportforetag.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent,
        FormsModule
    ]
})
export class SokTransportforetagComponent extends ControlValueAccessorBaseComponent {
    cachedSearch: Observable<TransportforetagSearchResultDTO[]> = null;
    lastSearch = null;
    selectedItem: TransportforetagSearchResultDTO;

    private readonly transportforetagService = inject(TransportforetagService);

    outputFormatter = (item: TransportforetagSearchResultDTO) => item?.id;

    search = (str) => {
        if (str !== this.lastSearch) {
            this.cachedSearch = null;
        }
        if (this.cachedSearch === null) {
            this.lastSearch = str;
            this.cachedSearch = this.transportforetagService.search(str, true).pipe(
                shareReplay(1)
            );
        }
        return this.cachedSearch;
    };

    viewFormatter = (item: TransportforetagSearchResultDTO) => `${item.huvudkod} ${item.namn}`;
}
